/**
 * Review app — /apps/review/*
 *
 * One job: an owner wants the periodic re-look — what moved, what changed, is
 * the ranking still true? Two screens (C Mode): Then vs Now, and the findings
 * worth challenging before you re-publish.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import ThenVsNowScreen from './ThenVsNowScreen';
import ChallengeScreen from './ChallengeScreen';

export default function ReviewApp() {
  const app = getAppDefinition('review')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<ThenVsNowScreen />} />
        <Route path="challenge" element={<ChallengeScreen />} />
        <Route path="*" element={<Navigate to="/apps/review" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
